export const UPLOAD_DOCUMENT_OPERATION = {
  ADD: "ADD",
  DELETE: "DELETE",
  UPDATE: "UPDATE",
};
